import {ActivatedRouteSnapshot, CanActivate, Router} from '@angular/router';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {SecurityService} from './security.service';
import {map} from 'rxjs/operators';

@Injectable()
export class AuthenticatedGuardService implements CanActivate {

  constructor(private securityService: SecurityService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | boolean {
    return this.securityService.isAuthenticated().pipe(map(
      (result: boolean) => {
        if (result) {
          return true;
        } else {
          this.router.navigate(['/contacts']);
          return false;
        }
      }
    ));
  }

}
